import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, WithScope } from '@mews-commander/types';
import { createEditFormConnect } from '../../entityManagement';
import { getSelectedContract } from '../selectors';
import { ContractInfoValues } from '../types';
import { updateContractAction } from '../actions';
import ContractForm from './ContractForm';

interface StateProps {
    initialValues: ContractInfoValues | null;
}

interface OwnProps extends WithScope {
    ownerId: string;
}

const connectContractForm = connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        initialValues: getSelectedContract,
        editMode: () => true,
    })
)(ContractForm);

const editContractConnect = createEditFormConnect({
    titleKey: TextKey.Contract,
    editAction: updateContractAction,
});

export default editContractConnect(connectContractForm);
